import React, { useState, useEffect } from 'react'

import { getNotas, postNota } from '@auteco/services/snopServices'
import './Notes.css'

const Notes = () => {
  const [notes, setNotes] = useState([])
  const [notesText, setNotesText] = useState([])

  const getNotes = async () => {
    const response = await getNotas()
    if (response) {
      console.log(response.bitacoras)
      setNotes(response.bitacoras)
    }
  }

  const handleChange = (e) => {
    if (e.target.value.length <= 150) {
      setNotesText(e.target.value)
    }
  }

  useEffect(() => {
    getNotes()
  }, [])

  const handleClick = async () => {
    await postNota({ contenido: notesText })
    await getNotes()
    setNotesText('')
  }

  return (
    <div>
      <br />

      <h3>Notas</h3>
      <textarea
        value={notesText}
        onChange={handleChange}
        style={{ resize: 'none' }}
        rows="4"
        cols="50"
        maxLength="100"
        className="textarea-n"
      />
      <br />

      <button className="button-n" onClick={handleClick}>
        Guardar nota
      </button>

      <br />

      {notes.map((note) => (
        <div className="note-container">
          <p>{note.contenido}</p>
        </div>
      ))}
    </div>
  )
}

export default Notes
